import axios from "axios";
import { checkUserAuthentication, getSessionHeaders } from "./login";

// ? check ends with /
export const parseAPI = (base_path) => {
  if (base_path.endsWith("/")) {
    return base_path;
  }
  return `${base_path}/`;
};

export async function getApiCatalog() {
  await checkUserAuthentication();
  const url =
    "/catalog/catalog.json";
  try {
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    console.error("Error fetching API catalog:", error);
    throw error;
  }
}

export function getIndustriesArray(catalog) {
  return (catalog && catalog.industries) || [];
}

export function findDomain(catalog, industryId, domainId) {
  const domains = getDomainsArray(catalog, industryId);
  return domains.find((domain) => domain.key === domainId);
}

export function getDomainsArray(catalog, industryId) {
  const industry = findIndustry(catalog, industryId);
  return (industry && industry.domains) || [];
}

export function findIndustry(catalog, industryId) {
  const industries = getIndustriesArray(catalog);
  return industries.find((industry) => industry.key === industryId);
}

export function getApisArray(catalog, industryId, domainId) {
  const domain = findDomain(catalog, industryId, domainId);
  return (domain && domain.apis) || [];
}

export function findApi(catalog, industryId, domainId, apiId) {
  const apis = getApisArray(catalog, industryId, domainId);
  return apis.find((api) => api.key === apiId);
}

export async function getApiResource(api, resourceId, extension) {
  const url = `/${api.path}${resourceId}.${extension}`;
  try {
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    console.error(`Error fetching API resource from ${url}:`, error);
    throw error;
  }
}

export function getFeaturedList(catalog) {
  const featuredApis = [];
  getIndustriesArray(catalog).forEach((industry) =>
    getDomainsArray(catalog, industry.key).forEach((domain) =>
      getApisArray(catalog, industry.key, domain.key).forEach((api) => {
        if (api.featured) {
          featuredApis.push({
            api,
            industry,
            domain,
          });
        }
      })
    )
  );
  return featuredApis;
}

export const getApisFromCatalog = (catalog) =>
  catalog.industries.reduce(
    (list, industry) => [...list, ...getApisFromIndustry(industry)],
    []
  );

export const getApisFromDomain = (domain) =>
  domain.apis.map((api) => ({
    title: api.title,
    key: api.key,
    path: api.path,
    domainTitle: domain.title,
    domainKey: domain.key,
  }));

export const getApisFromIndustry = (industry) =>
  industry.domains.reduce(
    (list, domain) => [
      ...list,
      ...getApisFromDomain(domain).map((api) => ({
        ...api,
        industryTitle: industry.title,
        industryKey: industry.key,
      })),
    ],
    []
  );
